import { appClientsService } from '@aslanpay/portal-common-lib';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface CreateAppClientParams {
  companyId: string;
}

interface CreateAppClientResponse {
  id: string;
  clientId: string;
  clientSecret: string;
  companyId: string;
}

const useCreateAppClient = () => {
  const queryClient = useQueryClient();

  return useMutation<CreateAppClientResponse, Error, CreateAppClientParams>({
    mutationFn: async ({ companyId }: CreateAppClientParams) => {
      return appClientsService.createAppClient(companyId);
    },
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['fetchCognitoAppClients', companyId] });
    },
  });
};

export default useCreateAppClient;
